import React, { useState } from "react";

import classNames from "classnames";

import styles from "./DropDownList.module.scss";

const DropDownList = ({ options, update, typeCount = false }) => {
  const [isOpen, setOpen] = useState(false);
  const [currentValue, setValue] = useState(options[0].title);
  const handleOpen = () => (isOpen ? setOpen(false) : setOpen(true));

  return (
    <div
      className={classNames(styles.wrap, {
        [styles["wrap-count"]]: typeCount,
      })}
    >
      <button
        className={classNames(styles["multi-down"], {
          [styles["multi-down-count"]]: typeCount,
        })}
        onClick={handleOpen}
      >
        {currentValue}<span className={classNames(styles.svg, {
          [styles.active]: isOpen
        })}>
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill="white" height={15} width={10} viewBox="0 0 129 129"  enable-background="new 0 0 129 129">
  <g>
    <path stroke="white" d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"/>
  </g>
</svg>
        </span>
      </button>
      <div
        className={classNames(styles.options, {
          [styles["options-count"]]: typeCount,
        })}
      >
        {isOpen &&
          options.map((child, key) => (
            <div className={styles["black-wrap"]} key={key}>
              <div
                onClick={() => {
                  setValue(child.title);

                  update(child.title);
                  setOpen(false);
                }}
                className={classNames(styles.option, {
                  [styles["option-count"]]: typeCount,
                })}
              >
                {child.title}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default DropDownList;
